import { useSelector, useDispatch } from "react-redux";
import {
  checkPinCodeAvailability,
  emptyPinCodeAvailability,
} from "../../Redux/ProductController/action";
import { useState, useEffect } from "react";
import { useToast } from "@chakra-ui/react";

function CheckLocationModal(props) {
  const { display, hidePinCodeModal } = props;
  const [pinCode, setPinCode] = useState("");
  const toast = useToast();

  const dispatch = useDispatch();
  const { checkPinCode } = useSelector((store) => store.prodReducer);

  useEffect(() => {
    if (checkPinCode && checkPinCode?.message && pinCode.length === 6) {
      toast({
        title: `${checkPinCode.message}`,
        status: `${checkPinCode.status ? "success" : "error"}`,
        duration: 3000,
        position: "top",
        isClosable: true,
      });

      if (checkPinCode.status) {
        hidePinCodeModal("hidden");
      }

      setTimeout(() => {
        dispatch(emptyPinCodeAvailability());
      }, 3001);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkPinCode, pinCode]);

  const submitFormHandler = () => {
    if (pinCode.length === 6) {
      dispatch(checkPinCodeAvailability(pinCode));
    }

    if (pinCode.length < 6) {
      toast({
        title: `Please Enter a valid PIN Code`,
        status: "info",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
    }
  };

  return (
    <>
      <div
        onClick={() => {
          hidePinCodeModal("hidden");
        }}
        className={`${display} fixed top-0 left-0 z-10 flex justify-center items-center w-full h-full bg-slate-300 bg-opacity-30 p-3`}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="flex flex-col rounded-md drop-shadow-lg max-w-96 bg-white"
        >
          <div className="bg-slate-400 py-3 rounded-t-md font-semibold">
            <h2>Check Your Location</h2>
          </div>

          <div className="flex flex-col py-3 px-5">
            <div className="max-w-sm text-sm md:text-base">
              <p>
                Select a delivery location to see product availability and
                delivery options
              </p>
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                submitFormHandler();
              }}
            >
              <div className="flex flex-col xsm:flex-row items-center justify-center gap-3 py-2">
                <input
                  type="number"
                  value={pinCode}
                  onChange={(e) => {
                    if (e.target.value.length <= 6) {
                      setPinCode(e.target.value);
                    }
                  }}
                  className="block rounded-md border-0 py-1.5 px-2 text-gray-900 max-w-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-300 sm:text-sm sm:leading-6"
                />
                <button
                  type="submit"
                  className="bg-[#F52E7D] hover:bg-[#f54088] w-28 text-white font-bold py-1.5 px-4 border border-[#F52E7D] rounded"
                >
                  Check
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default CheckLocationModal;
